"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./components/DetailsList/index"), exports);
//# sourceMappingURL=DetailsList.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/DetailsList.js
// module id = ../node_modules/office-ui-fabric-react/lib/DetailsList.js
// module chunks = 1